import React, { useEffect, useState } from 'react';
import FiscalYearPopUp from '../../FiscalYearPopUp';
import { Button, Dialog, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { gainData } from '../../SubActivity';
import { Box } from '@mui/system';
import GainTarget from './GainTarget';
import GainProgressUptoDate from './GainProgressUptoDate';
import GainAchievement from './GainAchievement';
import GainParcent from './GainParcent';
import GainQuantity from './GainQuantity';
import GainCumulative from './GainCumulative';
import useWorkPlanMainCreatetion from 'hooks/consume_api/mutation/useWorkPlanMainCreatetion';
import useWorkPlanFiscalYearCreation from 'hooks/consume_api/mutation/useWorkPlanFiscalYearCreation';
import useWorkPlanDelete from 'hooks/consume_api/mutation/useWorkPlanDelete';
import useFiscalYearCreate from 'hooks/consume_api/mutation/useFiscalYearCreate';
import useSnackbar from 'hooks/useSnackbar';

interface props {
    pOpen: boolean;
    pHandleClose: () => void;
}
const Gain: React.FC<props> = ({ pOpen, pHandleClose }) => {
    const snackbar = useSnackbar()

    const [open, setOpen] = useState<boolean>(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);

    const [startYear, setStartYear] = useState<string>('');
    const [endYear, setEndYear] = useState<string>('');
    const [cumulative, setCumulative] = useState<{ id: string; cumulativeValue: string }[]>([]);
    const [target, setTarget] = useState<{ startYear: string; endYear: string; id: string | number; target: string }[]>([]);
    const [progressUptoDate, setProgressUptoDate] = useState<{ id: string; uptoDate: string }[]>([]);
    const [fisCalYear, setFiscalYear] = useState<{ startYear: string; endYear: string }[]>([]);
    const [unit, setUnit] = useState<{ id: string | number; unit: string }[]>([]);
    const [achievement, setAchievement] = useState<{ id: string | number; value: string | number; startYear: string; endYear: string }[]>(
        []
    );

    const { mutate: worPlanMain } = useWorkPlanMainCreatetion();
    const { mutate: workPlanFiscalYear } = useWorkPlanFiscalYearCreation();
    const { mutate: workPlanDelete } = useWorkPlanDelete();
    const { mutate: fiscalYearCreate } = useFiscalYearCreate();

    const handleProgressUptoDate = (id: string, progressUptoDate: string) => {
        setProgressUptoDate((prev) => {
            const existingIndex = prev.findIndex((item) => item.id === id);
            if (existingIndex !== -1) {
                prev[existingIndex] = { id, uptoDate: progressUptoDate };
            } else {
                prev.push({ id, uptoDate: progressUptoDate });
            }
            return [...prev];
        });
    };

    const yearAssign = (startYear: string, endYear: string) => {
        setStartYear(startYear ? startYear : '');
        setEndYear(endYear ? endYear : '');
    };

    const handleAchievement = (id: string | number, value: string | number, startYear: string, endYear: string) => {
        setAchievement((prev) => [
            ...prev,
            {
                id,
                value,
                startYear,
                endYear
            }
        ]);
    };

    const handleTarget = (startYear: string, endYear: string, id: string | number, target: string) => {
        setTarget((prev) => {
            const existingIndex = prev.findIndex((item) => item.id === id && item.startYear === startYear && item.endYear === endYear);
            if (existingIndex !== -1) {
                prev[existingIndex] = { startYear, endYear, id, target };
            } else {
                prev.push({ startYear, endYear, id, target });
            }
            return [...prev];
        });
    };

    const handleUnit = (id: string | number, unit: string) => {
        setUnit((prev) => {
            const existingIndex = prev.findIndex((item) => item.id === id);
            if (existingIndex !== -1) {
                prev[existingIndex] = { id, unit };
            } else {
                prev.push({ id, unit });
            }
            return [...prev];
        });
    };

    const handleCumulative = (id: string, cumulativeValue: string) => {
        setCumulative((prev) => {
            const existingIndex = prev.findIndex((item) => item.id === id);
            if (existingIndex !== -1) {
                prev[existingIndex] = { id, cumulativeValue };
            } else {
                prev.push({ id, cumulativeValue });
            }
            return [...prev];
        });
    };

    useEffect(() => {
        if (startYear && endYear) {
            const existingFiscalYear = fisCalYear.find((fy) => fy.startYear === startYear && fy.endYear === endYear);
            if (!existingFiscalYear) {
                setFiscalYear((prevFiscalYears) => [...prevFiscalYears, { startYear: startYear, endYear: endYear }]);
            }
        }
    }, [startYear, endYear]);

    const handlePopUp = () => {
        handleOpen();
    };

    const handleSubmit = () => {
        if (fisCalYear.length) {
            fiscalYearCreate({
                agency: '6',
                jsonData: fisCalYear
            });

            let mainData: { id: string; projectName: string; unit: string; quantity: string; progressDate: string }[] = [];
            gainData.map((item) => {
                const quantityIndex = unit.findIndex((a) => a.id === item.valueText);
                const progressIndex = progressUptoDate.findIndex((a) => a.id === item.valueText);
                const cumulativeIndex = cumulative.findIndex((a) => a.id === item.valueText);
                let mainJson = {
                    id: item.valueText,
                    projectName: item.projectName,
                    unit: item.unit,
                    quantity: quantityIndex === -1 ? '0' : unit[quantityIndex].unit,
                    progressDate: progressIndex === -1 ? '0' : progressUptoDate[progressIndex].uptoDate,
                    cumulativeAchievement: cumulativeIndex === -1 ? '0' : cumulative[cumulativeIndex].cumulativeValue
                };
                worPlanMain({
                    agency: '6',
                    json: mainJson
                });
                mainData.push(mainJson);
            });

            let fiscalYearData: {
                subActivity: string | number;
                yearStart: string;
                yearEnd: string;
                target: string;
                achievement: string | number;
                parcent: string;
            }[] = [];

            achievement.map((item) => {
                const targetIndex = target.findIndex((t) => t.id === item.id && t.startYear === item.startYear && t.endYear === item.endYear);
                const currentTarget = targetIndex === -1 ? '0' : target[targetIndex].target;

                const calculatedPercent = (Number(item.value) / Number(currentTarget)) * 100;
                const currentPercent = isNaN(calculatedPercent) || !isFinite(calculatedPercent) ? '0' : calculatedPercent.toString();

                let fiscalYearJson = {
                    agency: '6',
                    subActivity: item.id,
                    yearStart: item.startYear,
                    yearEnd: item.endYear,
                    target: currentTarget,
                    achievement: item.value,
                    parcent: currentPercent
                };
                workPlanFiscalYear(fiscalYearJson);
                fiscalYearData.push(fiscalYearJson);
            });
            pHandleClose();
        } else {
            snackbar('Add fiscal year data', 'error');
        }
    };

    return (
        <div>
            <Dialog
                open={pOpen}
                onClose={pHandleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullWidth
            >
                <DialogContent>
                    <Button onClick={handlePopUp} variant="contained">
                        Add fiscal year
                    </Button>
                    <TableContainer sx={{ marginTop: '10px' }} component={Paper}>
                        <Box sx={{ height: 400, overflowY: 'auto' }}>
                            <Table stickyHeader sx={{ width: '100%' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="left">#</TableCell>
                                        <TableCell align="left">Sub-Activity</TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                            Project Name
                                        </TableCell>
                                        <TableCell align="left">Unit</TableCell>
                                        <TableCell align="left">Quantity</TableCell>
                                        {fisCalYear &&
                                            fisCalYear.map((item, index) => (
                                                <React.Fragment key={`fiscal-details-${index}`}>
                                                    <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                        {item.startYear} - {item.endYear} (Target)
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                        {item.startYear} - {item.endYear} (Achievement)
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                        {item.startYear} - {item.endYear} (%)
                                                    </TableCell>
                                                </React.Fragment>
                                            ))}
                                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                            Cumulative Achievement
                                        </TableCell>
                                        <TableCell sx={{ whiteSpace: 'nowrap' }} align="left">
                                            Progress upto date
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {gainData.map((gainItem, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="left">{index + 1}</TableCell>
                                            <TableCell align="left">{gainItem.label}</TableCell>
                                            <TableCell align="left">{gainItem.projectName}</TableCell>
                                            <TableCell align="left">{gainItem.unit}</TableCell>
                                            <TableCell align="left">
                                                <GainQuantity id={gainItem.valueText} handleUnit={handleUnit} />
                                            </TableCell>
                                            {fisCalYear &&
                                                fisCalYear.map((fitem, findex) => (
                                                    <React.Fragment key={`fiscal-detailss-${findex}`}>
                                                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                            <GainTarget
                                                                startYear={fitem.startYear}
                                                                endYear={fitem.endYear}
                                                                id={gainItem.valueText}
                                                                handleTarget={handleTarget}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                            <GainAchievement
                                                                startYear={fitem.startYear}
                                                                endYear={fitem.endYear}
                                                                valueText={gainItem.valueText}
                                                                handleAchievement={handleAchievement}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                                            <GainParcent
                                                                achievement={achievement}
                                                                startYear={fitem.startYear}
                                                                endYear={fitem.endYear}
                                                                id={gainItem.valueText}
                                                                target={target}
                                                            />
                                                        </TableCell>
                                                    </React.Fragment>
                                                ))}
                                            <TableCell align="left">
                                                <GainCumulative id={gainItem.valueText} handleCumative={handleCumulative} />
                                            </TableCell>
                                            <TableCell align="left">
                                                <GainProgressUptoDate id={gainItem.valueText} handleProgressUptoDate={handleProgressUptoDate} />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </TableContainer>
                    <Button sx={{ marginTop: '10px' }} onClick={handleSubmit} variant="contained">
                        Submit
                    </Button>
                    <FiscalYearPopUp open={open} handleClose={handleClose} yearAssign={yearAssign} />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default Gain;
